import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import TechOperationsForm from './TechOperationsForm';

export class TechOperationsCreateForm extends CreateView {
    protected getFormComponent() {
        return TechOperationsForm;
    }
}

export default TechOperationsCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(TechOperationsCreateForm));
